import { StyleSheet, Dimensions } from 'react-native';

const windowWidth = Dimensions.get('window').width;

const circleWidth = (windowWidth - 81) / 7;

export default StyleSheet.create({
  divider: {
    marginHorizontal: 16,
    width: (windowWidth - 50) / 2,
    height: 1,
  },
  bodyFirstSectionLineStyle: {
    marginLeft: 16,
    marginVertical: 32,
    height: 12,
    width: (windowWidth - 50) / 2 - 16 + 25,
  },
  bodySecondSectionSquareStyle: {
    width: 50,
    height: 245,
    marginLeft: (windowWidth - 50) / 2,
  },
  footerFirstSectionRightLineStyle: {
    marginRight: 39,
    height: 12,
    width: 52,
  },
  footerFirstSectionLeftLineStyle: {
    height: 12,
    width: (windowWidth - 50) / 2 - 16 + 25,
  },
  footerFirstSectionStyle: {
    marginLeft: 16,
    marginTop: 22,
  },
  footerSecondSectionFirstStyle: {
    marginTop: 17.9,
  },
  footerSecondSectionStyle: theme => ({
    marginTop: 23,
    marginBottom: 16,
    marginHorizontal: 16,
    borderWidth: 2,
    borderRadius: 6,
    borderColor: theme.colors.shimmerBorder,
    paddingLeft: 16,
    paddingRight: 21,
    paddingVertical: 17,
  }),
  footerSecondSectionSquareStyle: {
    width: 48,
    height: 32,
    marginRight: 19,
  },
  footerSecondSectionMainFirstLineStyle: {
    height: 12,
    marginBottom: 9,
  },
  footerSecondSectionMainSecondLineStyle: {
    height: 12,
  },
  footerSecondSectionRightLineStyle: {
    width: 52,
    height: 12,
    marginTop: 20.5,
  },
  footerThirdSectionSquareStyle: {
    marginHorizontal: 16,
    width: windowWidth - 32,
    height: 27,
    marginTop: 39,
  },
  bodyTitleLineStyle: {
    marginLeft: 16,
    marginTop: 28,
    marginBottom: 22,
    height: 12,
    width: ((windowWidth - 50) / 3) * 2,
  },
  firstSectionCircleStyle: {
    marginLeft: 16,
    width: circleWidth,
    height: circleWidth,
    borderRadius: circleWidth / 2,
    marginHorizontal: 3.5,
  },
  circleStyle: {
    width: circleWidth,
    height: circleWidth,
    borderRadius: circleWidth / 2,
    marginHorizontal: 3.5,
  },
  lastSectionCircleStyle: {
    marginRight: 16,
    marginHorizontal: 3.5,
    width: circleWidth,
    height: circleWidth,
    borderRadius: circleWidth / 2,
  },
  descriptionFirstSectionSquareStyle: {
    marginHorizontal: 16,
    width: windowWidth - 36,
    height: 9,
    marginTop: 20,
  },
  descriptionSecondSectionSquareStyle: {
    marginHorizontal: 16,
    width: windowWidth - 84,
    height: 9,
    marginTop: 10,
    marginBottom: 20,
  },
  bodySecondSectionRectangleStyle: {
    width: 106,
    height: 140,
    marginLeft: (windowWidth - 106) / 2,
    marginTop: 24,
  },
  leftCustomTabStyle: {
    marginLeft: 16,
    marginRight: 8,
    height: 46,
    width: (windowWidth - 48) / 2,
  },
  rightCustomTabStyle: {
    marginLeft: 8,
    marginRight: 16,
    height: 46,
    width: (windowWidth - 48) / 2,
  },
  titleStyle: {
    marginLeft: 16,
    marginTop: 16,
    marginBottom: 30,
  },
});
